var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { APP_ROUTES, useAppNavigate } from '@core';
import { LandingSections } from '@features/landing/constants';
import { useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
export var HeaderNavItem = function (_a) {
    var navOptions = _a.navOptions;
    var pathname = useLocation().pathname;
    var search = useSearchParams()[0];
    var navigate = useAppNavigate();
    var currentId = search.get('sectionId');
    var style = useMemo(function () {
        return (pathname.startsWith(APP_ROUTES.designing.route) &&
            navOptions.id === LandingSections.designing.id) ||
            navOptions.id === currentId
            ? 'text-primary'
            : 'text-input-value-black';
    }, [currentId]);
    var setSection = function () {
        navigate(APP_ROUTES.landing.route, { sectionId: navOptions.id });
    };
    return (_jsx("p", __assign({ className: twMerge('cursor-pointer text-xl font-medium', style), onClick: setSection }, { children: navOptions.text })));
};
